/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess202,
  PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess400,
  PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess401,
  PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess404,
  PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess500,
  PutApiV1ScholarshipfileapprovalScholarshipStatusInProcessMutationRequest,
  PutApiV1ScholarshipfileapprovalScholarshipStatusInProcessMutationResponse,
} from "../../types/scholarshipTypeFileApprovalController/PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess.ts";
import { setScholarshipInProcessRequestViewModelSchema } from "../setScholarshipInProcessRequestViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ScholarshipfileapprovalScholarshipStatusInProcess202Schema =
  z.boolean() as unknown as ToZod<PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ScholarshipfileapprovalScholarshipStatusInProcess400Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ScholarshipfileapprovalScholarshipStatusInProcess401Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ScholarshipfileapprovalScholarshipStatusInProcess404Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ScholarshipfileapprovalScholarshipStatusInProcess500Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalScholarshipStatusInProcess500>;

export const putApiV1ScholarshipfileapprovalScholarshipStatusInProcessMutationRequestSchema =
  z.lazy(
    () => setScholarshipInProcessRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalScholarshipStatusInProcessMutationRequest>;

export const putApiV1ScholarshipfileapprovalScholarshipStatusInProcessMutationResponseSchema =
  z.lazy(
    () => putApiV1ScholarshipfileapprovalScholarshipStatusInProcess202Schema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalScholarshipStatusInProcessMutationResponse>;
